import { proxy } from 'valtio';

import { ComponentSearchScore } from 'models';

const DEFAULT_COMPONENT_SEARCH_WEIGHTS: Partial<Record<ComponentSearchScore, number>> = {};

const componentSearchWeights = proxy<Partial<Record<ComponentSearchScore, number>>>(DEFAULT_COMPONENT_SEARCH_WEIGHTS);

export { componentSearchWeights, DEFAULT_COMPONENT_SEARCH_WEIGHTS };
